import { Select } from '@mantine/core';
import { UseFormReturnType as Form } from '@mantine/form';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { IFormInputSpecConstant } from 'pages/revisions-module/template-editor/editors/form/types';
import { IAutomationPlanNextRevision } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';

/**
 * Sub-form for plan-next-revision automation.
 */
export default function PlanNextRevisionSubForm({ form }: { form: Form<IAutomationPlanNextRevision> }) {
  const { allInputs } = useFormInputs();

  const dateInputs = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === 'revision' && input.spec.type === 'date')
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  const checkboxInputs = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === 'revision' && input.spec.type === 'checkbox')
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  const periodInputs = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === 'revision' && input.spec.type === 'period')
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  const documentValidUntilInputs = useMemo(
    () =>
      allInputs
        .filter((input) => {
          if (input.context !== 'revision') {
            return false;
          }

          if (input.spec.type === 'date' || input.spec.type === 'ifElse') {
            return true;
          }

          if (input.spec.type === 'constant') {
            return ((input.spec as IFormInputSpecConstant).constantType ?? 'text') === 'date';
          }

          return false;
        })
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  return (
    <>
      <Select
        data={dateInputs}
        label="Zobrať dátum ukončenia podľa poľa"
        required
        searchable
        size="sm"
        {...form.getInputProps('endDate')}
      />
      <Select
        data={checkboxInputs}
        label="Preplánovať iba ak je zaškrtnuté pole"
        placeholder="Preplánovať vždy"
        size="sm"
        clearable
        {...form.getInputProps('planIfChecked')}
      />
      <Select
        data={periodInputs}
        size="sm"
        placeholder="Ponechať termíny bez zmeny"
        label="Upraviť periódu termínov podľa poľa"
        clearable
        {...form.getInputProps('overridePeriod')}
      />
      <Select
        data={documentValidUntilInputs}
        size="sm"
        placeholder="Vypočítať automaticky"
        label="Nastaviť deadline na prepečiatkovanie podľa poľa"
        clearable
        searchable
        {...form.getInputProps('documentValidUntil')}
      />
    </>
  );
}
